export default __webpack_public_path__ + "static/media/chevron_lefth_active.628068c0.svg";